import { Outlet } from 'react-router-dom';

import MainLayout from '../components/layouts/MainLayout';

const PrivateRoute = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

export default PrivateRoute;
